/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./QiangZi.vue?vue&type=template&id=cb03b8e4&scoped=true&"
import script from "./QiangZi.vue?vue&type=script&lang=js&"
export * from "./QiangZi.vue?vue&type=script&lang=js&"
import style0 from "./QiangZi.vue?vue&type=style&index=0&id=cb03b8e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb03b8e4",
  null
  
)

export default component.exports